import { useTranslation } from 'react-i18next';
import { useMediaQueries } from '@/hooks';
import styles from './WarningPortraitMode.module.css';
import { useBodyClass } from './hooks/useBodyClass/useBodyClass';
import RotateDeviceIcon from '@/storybook/icons/RotateDeviceIcon';
import React from 'react';

const WarningOverlay = ({ children }: { children: React.ReactNode }) => {
  useBodyClass(styles.bodyOverflowHidden);
  return <div className={styles.landscape}>{children}</div>;
};

const RotateDeviceContent = () => {
  const { t } = useTranslation();
  return (
    <>
      <RotateDeviceIcon width={200} height={200} className={styles.rotateDevice} />
      <h2 className={styles.heading}>{t('main.rotateDevice.pleaseRotate')}</h2>
      <p className={styles.text}>{t('main.rotateDevice.pleaseRotateToLandscape')}</p>
    </>
  );
};

const NarrowDesktopContent = () => {
  const { t } = useTranslation();
  return (
    <>
      <h2 className={styles.heading}>{t('main.desktopUse.optimizedForDesktop')}</h2>
      <p className={styles.text}>{t('main.desktopUse.maximizeOrAdjust')}</p>
    </>
  );
};

const WarningPortraitMode = () => {
  const { landscape, isDesktop, isNarrowDesktop } = useMediaQueries();

  if (!isDesktop && !landscape) {
    return (
      <WarningOverlay>
        <RotateDeviceContent />
      </WarningOverlay>
    );
  }

  if (isDesktop && isNarrowDesktop) {
    return (
      <WarningOverlay>
        <NarrowDesktopContent />
      </WarningOverlay>
    );
  }

  return null;
};

export default WarningPortraitMode;
